import React from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import DOMPurify from 'dompurify';
import PropTypes from "prop-types";
import Footer from "../components/footer";
import Gotop from "../components/gotop";
import { Link } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import MapSingle from "../components/map/MapSingle";
import lo1 from "../assets/images/logo-company/cty4.png";
import StarProgress from "../components/progressBar/StarProgress";
import { useRef, useState, useEffect } from "react";
import Video from "../components/popup/Video";
import Gallery from "../components/popup/Gallery";
import { Collapse } from "react-collapse";
import logo from "../assets/images/logo.png";
import Header4 from "../components/header/Header4";
import Header03 from "../components/header/Header03";
import MobileHeader from "../components/header/MobileHeader";
import httpService from "../services/httpService";
import { getToken, redirectInternal } from "../services/authService";
import Avatar from 'react-avatar';

JobSingle.propTypes = {};

const marKers = [
  {
    id: 1,
    title: "Rockstar Games New York",
    name: "Senior UI/UX Designer",
    address: "Las Vegas, NV 89107, USA",
    longitude: -74.00122,
    latitude: 40.71023,
    img: lo1,
  },
];

function JobSingle(props) {
  const progressRef = useRef();
  const [targetHeight, setTargetHeight] = useState(0);
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);
  const [jobRelated, setRelatedJob] = useState([]);

  const [job, setJob] = useState(null);
  const [copyLinkState, setCopyLinkState] = useState(false);
  const [loadJobs, setLoadJob] = useState(true);
  const [loadRelatedJobs, setLoadRelatedJobs] = useState(true);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    if (progressRef?.current) {
      const offsetHeight = progressRef?.current?.offsetTop;
      setTargetHeight(offsetHeight);
    }
  }, [progressRef]);

  const jobSlug = window.location.pathname.split("/").pop();


  let shareUrl = window.location.href;
  let shareText = "";

  const getJob = async () => {
    try {
      const res = await httpService.get(`jobs/slug/${jobSlug}`);

      if (res.status === 200) {
        const category = res.data.data.industryCategory;
        const excludeJobId = res.data.data._id;
        const limit = 5;
        shareText = `Check out this job: ${res.data.data.jobTitle}`;
        setJob(res.data.data);
        getRelatedJobs(category, excludeJobId, limit);
        setLoadJob(false);
      }
    } catch (error) {
      setLoadJob(false);
      alert("Job wasn't successfully loaded, please reload and try again");
    }
  };

  const getRelatedJobs = async (category, excludeJobId, limit) => {
    try {
      const res = await httpService.get(`jobs/recent/jobs?category=${category}&excludeJobId=${excludeJobId}&limit=${limit}`);

      if (res.status === 200) {
        setRelatedJob(res.data.data);
        setLoadRelatedJobs(false)
      };
    } catch (error) {
      setLoadRelatedJobs(false);
      alert("Related Jobs wasn't successfully loaded, please reload and try again");
    }
  };

  useEffect(() => {
    getJob();
  }, [jobSlug]);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopyLinkState(true);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };


  const getSubById = async () => {
    try {
      const res = await httpService.get("/subscription/user-subscriptions");
      if (res.status === 200 && res.data.data === null) {
        localStorage.setItem("current-page", window.location.pathname);
        return redirectInternal("/pricing");
      };

      if (res.data.data.paymentStatus !== "true") {
        localStorage.setItem("current-page", window.location.pathname);
        return redirectInternal("/pricing");
      }
    } catch (error) { }
  };

  const checkForTokenAndPrice = () => {
    const userAuth = getToken();

    if (userAuth === null || userAuth === undefined || !userAuth) {
      localStorage.setItem("current-page", window.location.pathname);
      return redirectInternal("/login");
    };

    // check user pricing
    // getSubById();
  };

  useEffect(() => {
    checkForTokenAndPrice();
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>UKICNEWS - {job?.jobTitle || "Job Details"}</title>
          <meta
            name="description"
            content={`Explore the details of the UK sponsorship job: ${job?.jobTitle}. Find out about the role, requirements, and how to apply for this exciting opportunity.`}
          />
          <link rel="canonical" href={`https://www.ukicnews.com/jobs/${jobSlug}`} />

          {/* Open Graph (Facebook / LinkedIn preview) */}
          <meta property="og:type" content="website" />
          <meta property="og:title" content={`UKICNEWS | ${job?.jobTitle || "Latest Sponsorship Jobs"}`} />
          <meta
            property="og:description"
            content={`Explore the details of the UK sponsorship job: ${job?.jobTitle}. Find out about the role, requirements, and how to apply for this exciting opportunity.`}
          />
          <meta property="og:url" content={`https://www.ukicnews.com/jobs/${jobSlug}`} />
          <meta property="og:image" content="https://www.ukicnews.com/preview.png" />

          {/* Twitter preview */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={`UKICNEWS | ${job?.jobTitle || "Latest Sponsorship Jobs"}`} />
          <meta
            name="twitter:description"
            content={`Explore the details of the UK sponsorship job: ${job?.jobTitle}. Find out about the role, requirements, and how to apply for this exciting opportunity.`}
          />
          <meta name="twitter:image" content="https://www.ukicnews.com/preview.png" />
        </Helmet>
      </HelmetProvider>
      <MobileHeader handleMobile={handleMobile} />
      <Header03 clname="actJob2" handleMobile={handleMobile} />
      {loadJobs ? <section className="account-section">
        <div className="tf-container">
          <div className="row">
            <div className="wd-form-login">
              <h4>Loading job details...</h4>
            </div>
          </div>
        </div>
      </section> : (
        <>
          <section className="form-sticky fixed-space">
            <div className="tf-container">
              <div className="row">
                <div className="col-lg-12">
                  <div className="wd-job-author2">
                    <div className="content-left">
                      <div className="thumb">
                        <Avatar size="100" name={job?.jobTitle} />
                      </div>
                      <div className="content">
                        <Link to="#" className="category">
                          {job?.industryCategory || "Industry Category"}
                        </Link>
                        <h6>
                          <Link to="#">
                            {job?.jobTitle}
                          </Link>
                        </h6>
                        <ul className="job-info">
                          <li>
                            <span>{job?.companyName}</span>
                          </li>
                          <li>
                            <span className="icon-map-pin"></span>
                            <span>{job?.address}</span>
                          </li>
                          <li>
                            <span className="icon-calendar"></span>
                            <span>{formatDate(job?.createdAt)}</span>
                          </li>
                        </ul>
                        <ul className="tags">
                          <li>
                            <Link to="#">{job?.jobType}</Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="content-right">
                      <div className="top">
                        {job?.website !== "" && job?.website !== null ? <Link to={job?.website} className="btn btn-popup">
                          <i className="icon-send" />
                          Apply Now
                        </Link> : null}
                      </div>
                      {job?.email !== "" && job?.email !== null ? <div className="bottom">
                        <div className="price">
                          <span className="icon-send" />{`-`} Send an email to apply:
                          <a
                            style={{ color: "#007bff", textDecoration: "underline", fontSize: "14px" }}
                            href={`mailto:${job?.email}`}>{job?.email}</a>
                        </div>
                      </div> : null}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="inner-jobs-section">
            <div className="tf-container">
              <div className="row">
                <div className="col-lg-8">
                  <Tabs className="job-article tf-tab single-job">
                    <div className="content-tab">
                      <TabPanel className="inner-content animation-tab">
                        <h5>Full Job Description</h5>

                        <div className="divider">
                          <style>
                            {`
      .divider h1 { margin-top: 1em; font-size: 1.5rem; margin-bottom: 1em; }
      .divider h2 { font-size: 1.25rem; margin-bottom: 1em; }
      .divider h3 { font-size: 1.1rem; margin-bottom: 1em;}
      .divider h4, .divider h5, .divider h6 { font-size: 1rem; margin-bottom: 1em; }
      .divider p {    margin-bottom: 1em; line-height: 1.8; }
    `}
                          </style>
                          <div
                            dangerouslySetInnerHTML={{ __html: job?.jobDescription }}
                            style={{ fontSize: "1rem", lineHeight: "1.8", marginBottom: "1em" }}
                          />
                        </div>
                        <div className="post-navigation d-flex aln-center">
                          <div className="wd-social d-flex aln-center">
                            <span>Share on:</span>
                            <ul className="list-social d-flex aln-center">
                              <li><a
                                href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="icon-facebook"></i>
                              </a></li>
                              <li><a
                                href={`https://www.linkedin.com/sharing/share-offsite/?url=${shareUrl}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                <i className="icon-linkedin2"></i>
                              </a>
                              </li>
                              <li>
                                <a
                                  href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${`UK Sponsorship Job Alert: ${job?.jobTitle}`}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <i className="icon-twitter"></i>
                                </a>
                              </li>
                            </ul>
                          </div>
                          <Link to="#" onClick={handleCopyLink} className="frag-btn">
                            {copyLinkState ? "Link Copied!" : "Copy Link"}
                          </Link>
                        </div>



                        {loadRelatedJobs ? <section className="account-section">
                          <div className="tf-container">
                            <div className="row">
                              <div className="wd-form-login">
                                <h5>Loading related jobs...</h5>
                              </div>
                            </div>
                          </div>
                        </section> : <div className="related-job">
                          <h6>Related Jobs</h6>
                          {jobRelated.length === 0 && <p><i>{`There are no related jobs for ${job.jobTitle}`}</i></p>}
                          {jobRelated && jobRelated.map((jobItem) => (
                            <div className="features-job mg-bt-0 mt-3">
                              <div className="job-archive-header">

                                <div className="inner-box">
                                  <div className="logo-company">
                                    <Avatar size="40" name={jobItem.jobTitle} />
                                  </div>
                                  <div className="box-content">
                                    <h4>
                                      <Link to={`/jobs/${jobItem.slug}`}>
                                        {jobItem.industryCategory}
                                      </Link>
                                    </h4>
                                    <h3>
                                      <Link to={`/jobs/${jobItem.slug}`}>
                                        {jobItem.jobTitle}
                                      </Link>
                                    </h3>
                                    <ul>
                                      <li>
                                        <span className="icon-map-pin"></span>
                                        {jobItem.address}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="job-archive-footer">
                                <div className="job-footer">
                                  <ul className="job-tag mt-3">{jobItem.tags.map((tag, index) => (
                                    <li key={index}>
                                      <Link to={`/jobs/${jobItem.slug}`}> {tag}</Link>
                                    </li>
                                  ))}
                                  </ul>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>}

                      </TabPanel>

                    </div>
                  </Tabs>
                </div>
                <div className="col-lg-4">
                  <div className="cv-form-details po-sticky job-sg single-stick">
                    <ul className="list-infor">
                      <li>
                        <div className="category">Company</div>
                        <div className="detail">
                          {job?.companyName}
                        </div>
                      </li>
                      {job?.website && <li>
                        <div className="category">Website</div>
                        <div className="detail">
                          <Link to={job?.website || "#"}>
                            {job?.website}
                          </Link>
                        </div>
                      </li>}
                      {job?.email && <li>
                        <div className="category">Email</div>
                        <div className="detail">{job?.email}</div>
                      </li>}
                      <li>
                        <div className="category">Industry</div>
                        <div className="detail">{job?.industryCategory}</div>
                      </li>
                      <li>
                        <div className="category">Location</div>
                        <div className="detail">{job?.address}</div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section >
        </>)}

      <Footer shareText={shareText} shareUrl={shareUrl} />
      <Gotop />
    </>
  );
}

export default JobSingle;
